var movie = {};

movie.introMovie = promokit.video({
    el: '#player-intro',
    url: 'https://vod.plaync.com/BS/update/skywatcher/skywatcher_bg.mp4',
    controls: false,
    autoplay: false,
    loop: true,
    mute: true,
    preload : true
});
movie.bgMovie0 = promokit.video({
    el: '#bgVideo0',
    url: 'https://vod.plaync.com/BS/update/skywatcher/skywatcher1_1.mp4',
    controls: false,
    autoplay: false,
    loop: true,
    mute: true,
    preload : true
});
movie.bgMovie1 = promokit.video({
    el: '#bgVideo1',
    url: 'https://vod.plaync.com/BS/update/skywatcher/skywatcher1_2.mp4',
    controls: false,
    autoplay: false,
    loop: true,
    mute: true,
    preload : true
});
movie.bgMovie2 = promokit.video({
    el: '#bgVideo2',
    url: 'https://vod.plaync.com/BS/update/skywatcher/skywatcher1_3.mp4',
    controls: false,
    autoplay: false,
    loop: true,
    mute: true,
    preload : true
});
movie.bgMovie3 = promokit.video({
    el: '#bgVideo3',
    url: 'https://vod.plaync.com/BS/update/skywatcher/skywatcher2_1.mp4',
    controls: false,
    autoplay: false,
    loop: true,
    mute: true,
    preload : true
});
movie.bgMovie4 = promokit.video({
    el: '#bgVideo4',
    url: 'https://vod.plaync.com/BS/update/skywatcher/skywatcher2_2.mp4',
    controls: false,
    autoplay: false,
    loop: true,
    mute: true,
    preload : true
});

var Chundosa = (function() {

    var introChk = false;
    var intro = new TimelineMax({ paused: true })
    var _path = "";
    var _staticPath = {
        local: 'https://op-wstatic.ncsoft.com',
        op: 'https://op-wstatic.ncsoft.com',
        rc: 'https://rc-wstatic.plaync.co.kr',
        live: 'https://wstatic-cdn.plaync.com'
    };

    function Person(opts) {
        this.opts = opts;
        this.selector = {
            box: "[data-scene]"
        };
        this.state = {
            y: [],
            introTimer: null,
            resizeTimer: null,
            isScrolling: false,
            rsp: false
        };
        this.scenebox = {};
        this.movie = {};
        this.sequence = {};
        this.layer = {};
        this.slider = {};
        this.init();
    }

    Person.prototype = {
        init: function() {
            var context = this;
            this.state.length = $(this.selector.box).length - 1;

            this.staticPath();
            this.setMovie();
            this.setSlide();
            this.mouseWheel();
            this.resize();
            this.sceneSettings();
            this.controls();

            context.layout();
            context.sceneAnimation();
            context.state.isScrolling = true;

            movie.introMovie.play();
            setTimeout(function() {
                intro.seek(0);
                intro.play();
                context.remote(0);
            }, 100);
            context.state.isScrolling = false;
            $(window).trigger('resize');
        },
        staticPath: function() {
            var loc = location.href;
            var projectPath = '/promo/bns/history/2020/200617_update/';
            _path = _staticPath.live + projectPath;

            if (/rc\.|rc-/i.test(loc)) {
                _path = _staticPath.rc + projectPath;
            }
            if (/op\./i.test(loc)) {
                _path = _staticPath.op + projectPath;
            }
            if (/local\.|localhost|opdev\.|opdev-|ui-static\.|file:/i.test(loc)) {
                _path = _staticPath.local + projectPath;
            }
        },
        remote: function(target) {
            var $menu = $('#menu');
            var $bullet = $menu.find('a[data-anchor]');
            $menu.find('a').removeClass('on');
            // if (target == 0) {
            //     $menu.find('ol > li > a').addClass('on');
            // } else {
                $bullet.removeClass('on').eq(target ).addClass('on');
            // }
            $menu.find('ul').slideUp(300);
            var _ul = $bullet.eq(target).closest('ul');
            if (_ul.length) {
                _ul.stop().slideDown(300);
                _ul.siblings('a').addClass('on');
            }
            $menu.removeClass().addClass('active-' + target);
        },
        resize: function() {
            var context = this;
            $(window).resize(function() {
                sh = $(window).height();
                if (context.state.resizeTimer) {
                    clearTimeout(context.state.resizeTimer);
                }
                context.state.resizeTimer = setTimeout(function() {
                    context.state.resizeTimer = null;
                    context.layout();
                }, 100);
            }).resize();
        },
        mouseWheel: function() {
            var context = this;
            $(this.opts.el).on("mousewheel DOMMouseScroll", function(e) {
                context.wheelDelta(e);
            });
        },
        getwheelDelta: function(e) {
            if (e.type == "DOMMouseScroll") return e.originalEvent.detail < 0 ? 1 : -1;
            if (e.originalEvent.wheelDeltaY) return e.originalEvent.wheelDeltaY < 0 ? -1 : 1;
            return e.originalEvent.wheelDelta < 0 ? -1 : 1;
        },
        wheelDelta: function(e) {
            var context = this;
            if (!context.state.isScrolling) {
                context.state.isScrolling = true;
                if (context.getwheelDelta(e) < 0) {
                    this.scrollDown();
                } else {
                    this.scrollUp();
                }
                setTimeout(function() {
                    context.state.isScrolling = false;
                }, context.opts.wheelsp);
            }
            return false;
        },
        layout: function() {
            TweenMax.to([$("#container")], 0, { autoAlpha: 1 });
            TweenMax.to([$(this.opts.el).find($(this.selector.box))], 0, { autoAlpha: 1, y: '0%' });
            TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(this.opts.idx))], 0, { autoAlpha: 1, y: '0%', zIndex: 10 });
        },
        scrollDown: function() {
            if (this.opts.idx < this.state.length) {
                this.opts.before = this.opts.idx;
                this.opts.idx = this.opts.idx + 1;
            } else if (this.opts.idx == this.state.length) {
                return false;
            }
            this.moveAnimation();
        },
        scrollUp: function() {
            if (this.opts.idx > 0) {
                this.opts.before = this.opts.idx;
                this.opts.idx = this.opts.idx - 1;
            } else if (this.opts.idx == 0) {
                return false;
            }
            this.moveAnimation();
        },
        moveAnimation: function() {

            for (var i = 0; i < this.state.length + 1; i++) {
                if (this.opts.idx == i) {
                    if (this.opts.before > this.opts.idx) {
                        TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 0, { zIndex: '' }, { zIndex: 10 });
                        TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 1.2, { y: '-100%' }, { y: '0%', ease: Power4.easeInOut });
                    } else if (this.opts.before < this.opts.idx) {
                        TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 0, { zIndex: '' }, { zIndex: 10 });
                        TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 1.2, { y: '100%' }, { y: '0%', ease: Power4.easeInOut });
                    }
                } else if (this.opts.before == i) {
                    TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(i))], 0, { zIndex: 8, y: '0%' });
                } else {
                    TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(i))], 0, { zIndex: '', y: '0%' });
                }
            }
            this.sceneAnimation();
        },
        sceneSettings: function() {
            intro.addLabel('init')
                .add(function() {
                    $('#nav').addClass('active');
                    $('#intro').addClass('active');
                }, 'init+=0.6')
                .add(function() {
                    $('#section-footer').fadeIn();
                }, 'init+=3.2')
                .fromTo($(".rel_event"), 0.7, { x: 345 }, { x: 0, ease: Power3.easeOut }, 'init+=3.5')
                .fromTo($('.promokit-header-button'), 0.3, { opacity: 0, x: 30 }, { opacity: 1, x: 0, delay: 0, ease: Power2.easeOut }, "init+=3.65");


        },
        controls: function() {
            var context = this;
            $('#menu a').on('click', function(e) {
                e.preventDefault();
                var num = $(this).data('anchor');
                if (!($(this).data('anchor') >-1)) {
                    num = $(this).siblings('ul').find('a').eq(0).data('anchor');
                }
                if (context.opts.idx != num) {
                    context.opts.before = context.opts.idx;
                    context.opts.idx = num;
                    context.moveAnimation();
                }
                return false;
                
            });
            $('.js-btn_scroll').on('click', function() {
                context.opts.before = 0;
                context.opts.idx = 1;
                context.moveAnimation();
            })
            $('#menu > a').on('mouseenter', function() {
                $(this).addClass('hover');
            });
            $('#menu > a').on('mouseleave', function() {
                $(this).removeClass('hover');
            });

            $('#rel_event .js-control').on('click', function() {
                $('#rel_event').toggleClass('active');
            })
            $('.tab_btn a').on('click', function() {
                var _ul = $(this).closest('ul');
                var _scene = $(this).closest('.section');
                var idx = $('li', _ul).index($(this).closest('li'));
                $('li', _ul).removeClass('on');
                $(this).closest('li').addClass('on');
                _scene.find('.tab_cont_wrap li').removeClass('on');
                _scene.find('.tab_cont_wrap li').removeClass('play');
                _scene.find('.tab_cont_wrap li').eq(idx).addClass('on');
                setTimeout(function() {
                    _scene.find('.tab_cont_wrap li').eq(idx).addClass('play');
                },100);
            })
        },
        sceneAnimation: function() {
            var context = this;
            $.each(movie, function(index, value) {
                this.stopVideo = true;
            });
            if (this.opts.idx == 0) {
                //if (introChk) {
                    this.remote(0);
                    movie.introMovie.seek(0);
                    movie.introMovie.play();
                    movie.introMovie.stopVideo = false;
                //}
            } 
            else {
                this.remote(this.opts.idx);
            }
            if (this.opts.idx == 1) {
                movie.bgMovie0.seek(0);
                movie.bgMovie0.play();
                movie.bgMovie0.stopVideo = false;
            }
            if (this.opts.idx == 2) {
                movie.bgMovie1.seek(0);
                movie.bgMovie1.play();
                movie.bgMovie1.stopVideo = false;
            }
            if (this.opts.idx == 3) {
                movie.bgMovie2.seek(0);
                movie.bgMovie2.play();
                movie.bgMovie2.stopVideo = false;
            }
            if (this.opts.idx == 4) {
                movie.bgMovie3.seek(0);
                movie.bgMovie3.play();
                movie.bgMovie3.stopVideo = false;
            }
            if (this.opts.idx == 5) {
                movie.bgMovie4.seek(0);
                movie.bgMovie4.play();
                movie.bgMovie4.stopVideo = false;
            }
            setTimeout(function() {
                $('.section').removeClass('active');
                $('.section').eq(context.opts.idx).addClass('active');
                
                $.each(movie, function(index, value) {
                    if (this.stopVideo) { this.stop();}
                });
                
            },1000);
        },
        setSlide: function() {
            var context = this;
            this.slider.imgslider1 = new Swiper('.slider_doll', {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 10,
                speed: 800,
                loop:true,
                navigation: {
                    nextEl: '.swiper-button--doll-next',
                    prevEl: '.swiper-button--doll-prev',
                },
                allowTouchMove: false,
            });
            
            this.slider.imgslider1Detail = promokit.viewer({
                image: [
                {
                    src: _path + 'img/bns_image0.jpg'
                },
                {
                    src: _path + 'img/bns_image1.jpg'
                },
                {
                    src: _path + 'img/bns_image2.jpg'
                },
                {
                    src: _path + 'img/bns_image3.jpg'
                },
                {
                    src: _path + 'img/bns_image4.jpg'
                }
                ]
            });
            $('.slider_doll a').on('click', function() {
                //$('.slider_doll a').removeClass('on');
                //$(this).addClass('on');
                context.slider.imgslider1Detail.open($(this), $(this).data('index'))
            })
            $('.swiper-container').each(function() {
                var lngth = $(this).find('.swiper-slide').length;
                if (lngth <= 3) {
                    $(this).find('.swiper-control-wrap').hide();
                }
            });
        },
        setMovie: function() {

        }
    };

    return Person;

})();

//preload

promokit.preload({
    game: 'bns',
    complete: function() {
        window.Chundosa = new Chundosa({
            el: "#scene-box",
            idx: 0,
            before: 0,
            wheelsp: 1200
        });
    }
});


// WEBPACK FOOTER //
// ./src/js/index.js